<template>
  <div class="header-top">
    <div class="top-info">{{message}}</div>
    <div v-if="links" class="top-links">
      <span  v-for="link in links">
        <router-link  :to="link.router">{{link.text}}</router-link>
      </span>
    </div>
  </div>
</template>

<script>


  export default {
    data() {
      return {
        message: '',
        links: [],
      }
    },
    beforeMount() {
      this.message = this.$config.get('header.top.message');
      this.links = this.$config.get('header.top.links');
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/template/HeaderTop.vue